var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2199(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.444,
    height: 24.519,
    viewBox: "0 0 24.444 24.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(514.996 -131.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    "data-name": "Path 4436",
    d: "M-513.028,153.88h9.164V155.9c-.052,0-.106.014-.159.014q-4.456,0-8.912,0a1.972,1.972,0,0,1-2.029-1.644,4.12,4.12,0,0,1,.079-1.4,11.046,11.046,0,0,1,5.093-7.492c.508-.324,1.07-.564,1.608-.841.075-.039.154-.071.256-.117-.225-.186-.432-.343-.624-.518a6.94,6.94,0,0,1-2.378-6.131,7.079,7.079,0,0,1,6.067-6.3,7.13,7.13,0,0,1,8.07,5.894,7.122,7.122,0,0,1-5.632,8.172,8.18,8.18,0,0,1-1.591.157,9.193,9.193,0,0,0-8.688,6.711C-512.838,152.877-512.917,153.363-513.028,153.88Zm9.2-20.464a5.136,5.136,0,0,0-5.139,5.05,5.132,5.132,0,0,0,5,5.189,5.127,5.127,0,0,0,5.258-5.071A5.132,5.132,0,0,0-503.828,133.416Z",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4437",
    "data-name": "Path 4437",
    d: "M-253.5,390.366c0-.69,0-1.352,0-2.013a1.007,1.007,0,0,0-.85-1.034,1.018,1.018,0,0,0-.947.344q-1.4,1.4-2.8,2.8-1.076,1.076-2.152,2.152a1.028,1.028,0,0,0,0,1.63q2.482,2.483,4.966,4.964a1,1,0,0,0,1.691-.286,1.413,1.413,0,0,0,.084-.49c.009-.637,0-1.274,0-1.941h3.966a1.024,1.024,0,0,0,1.138-1.119q.006-1.941,0-3.882a1.023,1.023,0,0,0-1.137-1.12H-253.5Zm3.073,4.1h-.33c-1.214,0-2.427,0-3.641,0a1.019,1.019,0,0,0-1.132,1.123c0,.145,0,.291,0,.415l-2.559-2.559,2.558-2.558c0,.046.005.133,0,.219-.058.847.395,1.326,1.3,1.3,1.165-.034,2.331-.009,3.5-.008.1,0,.2.009.3.015Z",
    transform: "translate(-242.162 -243.642)",
    fill: "#4c5b71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2199);
export default __webpack_public_path__ + "static/media/Group 2199.0fdf62fd67bb9f316bfff3cc57be86ed.svg";
export { ForwardRef as ReactComponent };